import * as React from 'react';
import { Subject } from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ApiQueryData} from 'PyzShopUi/scripts/product-detail-page/interfaces';
import usePrevious from 'PyzShopUi/scripts/shop-ui/hooks/usePrevious';
import {getProductVariantData} from '../actions/get-variant';
import isEqual from 'react-fast-compare';
import { LIST_LOAD_DEBOUNCE_TIME } from '../constants';

interface UpdateObject {
    // tslint:disable-next-line:no-any
    dispatch: React.Dispatch<any>;
    apiQueryData: ApiQueryData;
}

// tslint:disable-next-line:no-any
function useApiQueryDataUpdate(apiQueryData: ApiQueryData, dispatch: React.Dispatch<any>) {
    const updateProductVariantDataObserver = React.useRef(new Subject<UpdateObject>());
    const previousApiQueryData = usePrevious(apiQueryData);

    React.useEffect(() => {
        const subscription = updateProductVariantDataObserver.current
            .pipe(debounceTime(LIST_LOAD_DEBOUNCE_TIME))
            .subscribe(object => {
                object.dispatch(
                    getProductVariantData(
                        object.apiQueryData
                    )
                );
            });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    React.useEffect(() => {
        if (!isAllowToUpdate(apiQueryData, previousApiQueryData)) {
            return undefined;
        }

        updateProductVariantDataObserver.current.next({
            dispatch,
            apiQueryData
        });
    }, [apiQueryData]);
}

const isAllowToUpdate = (apiQueryData: ApiQueryData, previousApiQueryData: ApiQueryData): boolean => (
    previousApiQueryData !== undefined &&
    Object.keys(apiQueryData).length &&
    !isEqual(copyAndIgnoringEmptyKeys(previousApiQueryData), copyAndIgnoringEmptyKeys(apiQueryData)) &&
    +apiQueryData.page !== 0 // prevent api call when empty list is returned
);

function copyAndIgnoringEmptyKeys(input: object): object {
    const output = {};

    if (!input) {
        return output;
    }

    Object.keys(input).forEach(key => {
        if (input[key] === undefined
            || input[key] === null
            || (typeof input[key] === 'object' && Object.keys(input[key]).length === 0)
        ) {
            return;
        }

        output[key] = input[key];
    });

    return output;
}

export default useApiQueryDataUpdate;
